var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "typeahead-group" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.myValue.value === null,
            expression: "myValue.value === null"
          }
        ]
      },
      [
        _vm.loading
          ? _c("i", { staticClass: "fa fa-spinner fa-spin" })
          : _vm._e(),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.query,
              expression: "query"
            }
          ],
          staticClass: "form-control ",
          attrs: {
            type: "text",
            placeholder: _vm.placeholder,
            autocomplete: "off",
            autofocus:
              typeof _vm.preventAutofocus !== "undefined" &&
              !_vm.preventAutofocus
                ? false
                : true
          },
          domProps: { value: _vm.query },
          on: {
            keydown: [
              function($event) {
                if (
                  !("button" in $event) &&
                  _vm._k($event.keyCode, "down", 40, $event.key, [
                    "Down",
                    "ArrowDown"
                  ])
                ) {
                  return null
                }
                return _vm.down($event)
              },
              function($event) {
                if (
                  !("button" in $event) &&
                  _vm._k($event.keyCode, "up", 38, $event.key, [
                    "Up",
                    "ArrowUp"
                  ])
                ) {
                  return null
                }
                return _vm.up($event)
              },
              function($event) {
                if (
                  !("button" in $event) &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.hit($event)
              },
              function($event) {
                if (
                  !("button" in $event) &&
                  _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")
                ) {
                  return null
                }
                return _vm.onKeyUpEsc($event)
              }
            ],
            blur: _vm.onBlur,
            input: [
              function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.query = $event.target.value
              },
              _vm.update
            ]
          }
        }),
        _vm._v(" "),
        _c(
          "ul",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.hasItems,
                expression: "hasItems"
              }
            ]
          },
          _vm._l(_vm.items, function(item, $item) {
            return _c(
              "li",
              {
                key: item.id,
                class: _vm.activeClass($item),
                on: {
                  mousedown: _vm.hit,
                  mousemove: function($event) {
                    _vm.setActive($item)
                  }
                }
              },
              [_c("span", { domProps: { textContent: _vm._s(item.name) } })]
            )
          })
        )
      ]
    ),
    _vm._v(" "),
    _c("i", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.myValue.value !== null,
          expression: "myValue.value !== null"
        }
      ],
      staticClass: "fa fa-times reset",
      on: { click: _vm.resetTypeahead }
    }),
    _vm._v(" "),
    _c("input", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.myValue.value !== null,
          expression: "myValue.value !== null"
        },
        {
          name: "model",
          rawName: "v-model",
          value: _vm.myValue.label,
          expression: "myValue.label"
        }
      ],
      staticClass: "form-control typeahead-value",
      attrs: { type: "text", readonly: "" },
      domProps: { value: _vm.myValue.label },
      on: {
        input: function($event) {
          if ($event.target.composing) {
            return
          }
          _vm.$set(_vm.myValue, "label", $event.target.value)
        }
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-09f45172", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09f45172","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Typeahead.vue
// module id = EbPj
// module chunks = 4